import * as React from 'react';
import { IS_ALARM, IS_EVENT, IS_PAUSE, IS_WAYPOINT } from '../constants';
import AlarmEventItem from './AlarmEventItem';
import EventEventItem from './EventEventItem';
import { IEvent } from './EventsWidget';
import PauseEventItem from './PauseEventItem';
import WaypointEventItem from './WaypointEventItem';

export default function EventItem(
  event: IEvent,
  index: number,
  isInTooltip = false
): JSX.Element | null {
  if (event.type === IS_ALARM) {
    return AlarmEventItem(event, index, isInTooltip);
  }
  if (event.type === IS_WAYPOINT) {
    return WaypointEventItem(event, index, isInTooltip);
  }
  if (event.type === IS_PAUSE) {
    return PauseEventItem(event, index, isInTooltip);
  }
  if (event.type === IS_EVENT) {
    return EventEventItem(event, index, isInTooltip);
  }
  return null;
}
